import React from 'react';
import { useTranslation } from 'react-i18next';
import video_mobile from "../../images/video/VIDEO_MOB_2_DOTATION.webm";
import video_desktop from "../../images/video/VIDEO_WEB.webm";

const Prochainement = () => {

  const { t } = useTranslation();

  return (
    <div className={"strate footer"} id={"prochainementStrate"}>
      <h1 dangerouslySetInnerHTML={{ __html: t("prochainement_prochainement") }} />

      <div className={"visuel"} />

      <div className={"subtitle"} dangerouslySetInnerHTML={{ __html: t("prochainement_subtitle") }} />

      <p dangerouslySetInnerHTML={{ __html: t("prochainement_paragraph") }} />
    </div>
  );
}
export default Prochainement;
